import React from 'react';
import SidebarController from '../../components/Sidebar/SidebarController';
import useUserProfile from '../../hooks/UserProfileHook';
import Spinner from '../../components/Spinner';
import useSidebarMenu from '../../hooks/SidebarMenuHook';

const AuthenticatedRouter: React.FC = ({ children }) => {
  const { data: userProfile } = useUserProfile();
  const {
    isAllowed: isRoutingAllowed,
  } = useSidebarMenu();

  function rolesAllowed() {
    return isRoutingAllowed();
  }

  function render() {
    if (userProfile === undefined) {
      return <Spinner />;
    }

    if (rolesAllowed()) {
      // return only sidebar controller.
      return React.Children.toArray(children).filter(
        (child) => React.isValidElement(child) && child.type === SidebarController,
      );
    }
    return (
      React.Children.toArray(children).slice(1)
    );
  }

  return (<div>{ render() }</div>);
};

export default AuthenticatedRouter;
